import { useCustomer } from '@/hooks/use-customer';

export const useIsCustomer = () => {
  return !!useCustomer().token;
};
